var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 780 215.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#eb2026;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "10MS - SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.16 215.6 27.62 215.6 27.62 30.54 0 30.54 0 0 58.16 0 58.16 215.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.9,125.73,232,63.62C225.21,30.46,198.84,4.43,165.43.25c-.63-.08-1.27-.15-1.9-.21V30.83C178,33.28,190,42.64,197,55.52l-48.64,48.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203,114.26l-.13,20.3v.1c0,27.77-21.14,50.36-47.12,50.36s-47.1-22.57-47.12-50.31L109,80.66v-.1c0-24.68,16.76-45.66,39.31-49.67V.07l-2,.23C107.6,5.38,78.44,39.86,78.41,80.51l-.35,54.05v.1c0,44.61,34.84,80.9,77.66,80.9s77.63-36.26,77.65-80.85l.34-51.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "350.6 0.14 350.6 97.66 337.21 97.66 337.21 30.55 306.93 97.8 277.64 30.55 277.64 97.66 264.24 97.66 264.24 0.14 280.29 0.14 306.93 63.48 334.7 0.14 350.6 0.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 383.32,
    y: 0.14,
    width: 13.53,
    height: 97.79
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "501.49 0.14 501.49 97.8 486.14 97.8 443.31 24 443.31 97.8 430.2 97.8 430.2 0.14 445.69 0.14 488.65 75.75 488.65 0.14 501.49 0.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M601.59,0V63.48A35,35,0,0,1,537.42,82a36.07,36.07,0,0,1-5.72-18.55V0h13.39V62.78a21.49,21.49,0,0,0,43,0V0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "700.57 0 700.57 12.97 667.78 12.84 668.06 97.93 654.25 97.93 654.39 12.84 622.17 12.84 622.17 0 700.57 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780 84.82 780 97.79 720.76 97.79 720.76 0.14 780 0.14 780 13.25 734.16 13.25 734.16 43.25 769.17 43.25 769.17 56.22 734.16 56.22 734.16 84.82 780 84.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.52,214.88c-12.13,0-23.28-5.71-29.28-13.94v-.28l5.58-9.48c4.32,6.28,12.68,11.16,23.84,11.85h3.62c9.62,0,17.57-7.11,17.57-16.72s-7.53-13.53-17.57-15.06a65.86,65.86,0,0,0-6.55-1c-13.8-2.64-26.21-10.73-26.21-25.37S276.37,118,290.73,118h2.09c9.62,0,19.93,4.18,25.09,10.73l-6.27,11.57c-5.44-6-10.59-9.34-18.82-9.76h-2.09c-7.39,0-13.52,6.7-13.52,14.36,0,7.39,5.16,11.43,13.52,12.55,3.49.42,5.85.56,6.83.7,16.59,2.23,29.14,11.71,29.14,28.16s-13.25,28.15-29.42,28.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M412.2,206.24a47.92,47.92,0,0,1-28,8.92,48.79,48.79,0,0,1,0-97.58,47.88,47.88,0,0,1,28,8.78l-6.13,12.83a33.41,33.41,0,0,0-21.89-7.53,34.78,34.78,0,1,0,22.3,61.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "498.09 117.58 498.09 215.02 484.57 215.02 484.57 174.32 440.1 174.32 440.1 215.02 426.58 215.02 426.58 117.58 440.1 117.58 440.1 162.05 484.57 162.05 484.57 117.58 498.09 117.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M606.49,166.09C606.49,193,586,215,559,215c-25.65,0-46.28-22-46.28-48.93,0-26.76,20.63-48.65,46.28-48.65,27,0,47.53,21.89,47.53,48.65m-13.38,0c0-19.37-14.64-35.13-34.15-35.13-18.27,0-32.9,15.76-32.9,35.13,0,19.66,14.63,35.55,32.9,35.55,19.51,0,34.15-15.89,34.15-35.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M711.16,166.09c0,26.91-20.49,48.93-47.53,48.93-25.66,0-46.29-22-46.29-48.93,0-26.76,20.63-48.65,46.29-48.65,27,0,47.53,21.89,47.53,48.65m-13.38,0c0-19.37-14.64-35.13-34.15-35.13-18.27,0-32.91,15.76-32.91,35.13,0,19.66,14.64,35.55,32.91,35.55,19.51,0,34.15-15.89,34.15-35.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "739.02 201.92 780 201.92 780 215.16 725.77 215.16 725.77 117.58 739.02 117.58 739.02 201.92"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.958a52ed17f966d29db4e2a203297df1.svg";
export { ForwardRef as ReactComponent };